// extracted by mini-css-extract-plugin
export default {"icon":"CustomDropzone_icon__hkgnR","iconError":"CustomDropzone_iconError__s3HSE","iconSucces":"CustomDropzone_iconSucces__5tLpV","iconCheck":"CustomDropzone_iconCheck__eQARX"};